import { IEmployee } from "../model/LoginModel";
import { SessionStorage } from "../services/storage";

export const SOLUTION_DIVISION_ID = 16;
export const ALL_DIVISION_ID = 15;
export const ALL_BUSINESS_ID = 9;
export const NETWORK_ID = 12;

const getEmployeeDetail = (): IEmployee => {
    const session = SessionStorage.get('employee') ?? '{}';
    return JSON.parse(session) ?? {};
};

export const isAllDivisionUser = (forceSet: boolean = false) => forceSet || getEmployeeDetail().divisionId === ALL_DIVISION_ID;
export const isAllBusinessUser = (forceSet: boolean = false) => forceSet || getEmployeeDetail().businessId === ALL_BUSINESS_ID;
export const isNetworkUser = (forceSet: boolean = false) => forceSet || getEmployeeDetail().divisionId === NETWORK_ID;

export const isSolutionDivisionUser = (id: number) => {
    const empDivisionId = getEmployeeDetail().divisionId;
    return empDivisionId === SOLUTION_DIVISION_ID
        ? [13, 14, 16, 17]?.includes(id)
        : id === empDivisionId;
};